import React, { useState, useEffect, useRef, useCallback } from 'react';
import withStyles from '@mui/styles/withStyles';
import { useStylesCustomTable } from './style';
import createToast from 'components/Toast/Toast';
import { validator } from 'myValidation';
import { useForm, FormProvider } from 'react-hook-form';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  Button,
  Grid,
  useMediaQuery
} from '@mui/material';
import IssueInvoiceServices from '../services/IssueInvoiceServices';
import { InputV2, InputCurrency , AutocompleteV, Icons, SimpleDialog, ButtonLoading } from 'components';
import { useProductsList } from 'hooks';
import _ from 'lodash';
export default function CustomizedTables({
  methods,
  defaultValues,
  selectedProducts,
  setSelectedProducts,
}) {
  const classes = useStylesCustomTable();
  const [productSearchText, setProductSearchText] = useState('');
  const [dialogLoading, setDialogLoading] = useState(false);
  const [newProduct, setNewProduct] = useState(false);
  const methodsDialog = useForm();
  const { handleSubmit } = methodsDialog;

  const { productsList, getProductsList, productsLoading } = useProductsList();
  const [currentProduct, setCurrentProduct] = useState(null);
  const delayedQuery = useRef(_.debounce((v, f) => f(v), 500)).current;
  const matches = useMediaQuery('(max-width:600px)');
  const fieldStyle = {
    marginTop: 16, width: 150
  };
  /**
* جستجوی سرویسی محصولات 
*/
  useEffect(() => {
    delayedQuery(productSearchText, getProductsList);
  }, [productSearchText]);


  /**
* بررسی محصولات انتخاب شده و ثبت آنها در متدهای فرم
*/
  useEffect(() => {
    methods.register('product');
    return () => {
      methods.unregister('product');
    };
  }, [methods.register, methods.unregister]);


  /**
* تغییر فیلد محصولات انتخاب شده   
*/
  const onChangeProduct = (val, type, i) => {
    selectedProducts[i][type] = val;
    setSelectedProducts([...selectedProducts]);

  }

  /**
  * چک میکند آیا متن وارد شده شامل تگ اسکریپت هست یا خیر !
  */
  const checkScriptTagInText = (values) => {
    const v = validator.matches(
      String(values).trim() ?? '',
      /<[^>]*>/g,
    );
    return v;
  }

  /**
* در خصوص فیلد توضیحات میباشد که معتبر هست یا نه  
*/
  const onCheckValidValue = (i) => {
    if (checkScriptTagInText(selectedProducts[i]['description'])) {
      selectedProducts[i]['description'] = '';
      setSelectedProducts([...selectedProducts]);
      return createToast(
        'خطا',
        'توضیحات وارد شده معتبر نیست.',
        'danger',
      );
    }
  }

  const handleCloseDialog = () => {
    setNewProduct(false);
  };


  const submitDialog = async () => {

    const formValues = methodsDialog.getValues();
    setDialogLoading(true);
    const productBody = {
      name: formValues?.productName,
      price: formValues?.priceProduct,
      availableCount: formValues?.volumeProduct,
    }
    try {
      let res = await IssueInvoiceServices.addNewProduct(productBody);
      setNewProduct(false);
      onAddItem({ id: res?.result?.entityId, name: res?.result?.name, price: res?.result?.price });
    } catch (error) {
    } finally {
      setDialogLoading(false);
    }
  };
  const ActionsBtn = () => {
    return (
      <>
        <ButtonLoading
          variant="contained"
          color="primary"
          loading={dialogLoading}
          name="افزودن"
          disabled={dialogLoading}
          onClick={handleSubmit(submitDialog)}
          type="submit"
        />

        <Button variant="contained" onClick={handleCloseDialog} disabled={dialogLoading}>
          انصراف
        </Button>
      </>
    );
  };

  /**
* افزودن محصول جدید به لیست محصولات انتخاب شده و اعتبار سنجی آن
*/
  const onAddItem = useCallback(
    (p) => {
      if (!p.name || p.name.trim() === '') {

        return createToast(
          'خطا',
          'عنوان محصول را وارد کنید!',
          'danger',
        );
      }
      setProductSearchText('');
      setSelectedProducts((state) => [
        ...state,
        {
          id: p.id,
          name: p.name,
          description: '',
          price: p.price,
          quantity: '',
          discount: '',
        },
      ]);
      setCurrentProduct(null);
    },
    [currentProduct],
  );


  const productsTableData = () => {
    const formValues = methods.getValues();
    const data = selectedProducts.map?.((p, i) => ({
      deleteAction: (
        <IconButton onClick={() => removeProduct(i)} size="large">
          <Icons icon="Trash" color="#2b3990" size="20" />
        </IconButton>
      ),
      id: p.id,
      name: p.name,
      description: (
        <InputV2
          name={`product[${i}].description`}
          label="توضیحات"
          showLabel={false}
          errors={methods.formState.errors}
          className={classes.field}
          register={methods.register}
          placeholder={'متن را وارد کنید ...'}
          control={methods.control}
          style={{ marginTop: 16, width: matches ? '300px' : '100%' }}
          defaultValue={p.description}
          forceValue={p.description}
          onBlur={() => { onCheckValidValue(i) }}
          onChangeValue={
            (e) => {
              onChangeProduct(e?.target?.value, 'description', i);
            }
          }

        />
      ),
      price: (
        <InputCurrency
          name={`product[${i}].price`}
          label="قیمت"
          showLabel={false}
          errors={methods.formState.errors}
          register={methods.register}
          rules={['required', 'isInt']}
          control={methods.control}
          currency
          className={classes.field}
          defaultValue={p.price}
          style={{ marginTop: 16, width: 200 }}
          forceValue={p.price}
          onChangeValue={(price) => {

            const discount = Number(formValues.product?.[i]?.discount);
            onChangeProduct(price, 'price', i);
            if (Number(discount) > price) {
              methods.setError(`product[${i}].discount`, {
                message: `تخفیف نباید از ${price} بیشتر باشد`,
              });
            } else if (Number(discount) <= price) {
              methods.setError(`product[${i}].discount`, {
                message: null,
              });
            }
          }}
        />
      ),
      quantity: (
        <InputV2
          name={`product[${i}].quantity`}
          label="تعداد"
          showLabel={false}
          errors={methods.formState.errors}
          register={methods.register}
          rules={['required', 'isInt']}
          control={methods.control}
          className={classes.field}
          currency
          defaultValue={p.quantity}
          forceValue={p.quantity}
          currencyText="عدد"
          style={fieldStyle}
          onChangeValue={(quantity) => onChangeProduct(quantity, 'quantity', i)}
        />
      ),
      discount: (
        <InputCurrency
          name={`product[${i}].discount`}
          label="تخفیف"
          showLabel={false}
          errors={methods.formState.errors}
          register={methods.register}
          className={classes.field}
          defaultValue={p.discount}
          rules={[
            'isInt',
            'isMin|0',
            'required',
            `isMax|${methods.watch(`product[${i}].price`) ?? null}`,
          ]}
          control={methods.control}
          forceValue={p.discount}
          style={fieldStyle}
          onChangeValue={(discount) => onChangeProduct(discount, 'discount', i)}

        />
      ),
    }));

    /**
    * حذف محصول از لیست محصولات انتخاب شده
    */
    const removeProduct = (i) => {
      const newState = selectedProducts.filter((_, index) => index !== i);
      setSelectedProducts(newState);
    };

    return data || [];
  };



  return (
    <>
      <Grid
        container
        direction="row"
        alignItems="center"
        spacing={2}
        item
        className={classes.root}
      >
        <Grid item xs={12} container alignItems="center" >
          <div className={classes.autocompleteWrapper}>
            <AutocompleteV
              placeholder="جستجو در محصولات کسب‌وکار..."
              control={methods.control}
              filterOptions={(options) => options}
              errors={methods.formState.errors}
              register={methods.register}
              name="product_auto"
              list={productsList}
              preventAddCustomOption
              style={{ marginBottom: -4 }}
              loading={productsLoading}
              getOptionSelected={(option, value) => option?.id === value.id}
              getOptionDisabled={(option) =>
                selectedProducts.find((v) => v?.id === option?.id) != null
              }
              inputValue={productSearchText ?? ''}
              onInputChange={(e) => {
                if (e?.target?.value === productSearchText) return;
                setProductSearchText(e?.target?.value ?? '');
              }}
              forceValue={0}
              disableClearable
              defaultValue={
                defaultValues?.id
                  ? {
                    value: defaultValues?.id,
                    name: defaultValues?.name,
                    label: `${defaultValues?.name} - ${defaultValues?.id}`,
                  }
                  : null
              }
              onChangeValue={(p) => {
                if (!p) return;
                onAddItem(p);

              }}
            />
          </div>


          <Typography className={classes.orText}>یا</Typography>
          <Button
            variant="outlined"
            color="primary"
            type="button"
            fullWidth
            className={classes.addPro}
            onClick={() => {
              setNewProduct(true);
            }}
          >
            افزودن محصول جدید
          </Button>
        </Grid>
      </Grid>
      <TableContainer component={Paper} className={classes.tableWrapperMain}>
        {productsTableData().length > 0 ? (
          <div className={classes.tableWrapper}>

            <Table className={classes.table} aria-label="customized table">
              {
                productsTableData().length > 0 && (
                  <TableHead className={classes.thead}>
                    <TableRow>
                      <StyledTableCell align="center">ردیف</StyledTableCell>
                      <StyledTableCell align="center">شناسه محصول</StyledTableCell>
                      <StyledTableCell align="center">نام محصول</StyledTableCell>
                      <StyledTableCell align="center" width="30%">
                        توضیحات
                      </StyledTableCell>
                      <StyledTableCell align="center">قیمت</StyledTableCell>
                      <StyledTableCell align="center">تعداد</StyledTableCell>
                      <StyledTableCell align="center">تخفیف</StyledTableCell>
                      <StyledTableCell align="center">عملیات</StyledTableCell>
                    </TableRow>
                  </TableHead>
                )
              }
              <TableBody className={classes.tbody}>
                {productsTableData().map?.((p, i) => (
                  <StyledTableRow key={i}>
                    {[
                      i + 1,
                      p.id,
                      p.name,
                      p.description,
                      p.price,
                      p.quantity,
                      p.discount,
                      p.deleteAction,
                    ].map((x) => (
                      <StyledTableCell>{x}</StyledTableCell>
                    ))}
                  </StyledTableRow>
                ))}
              </TableBody>

            </Table>
          </div>
        ) : ('')}

      </TableContainer>
      <SimpleDialog
        customClass={classes.customClassdialogContent}
        open={newProduct}
        icon={<Icons icon="plusCircle" color="#2B398E" size="20" />}
        title={'افزودن محصول جدید'}
        actions={<ActionsBtn />}>
        <FormProvider {...methodsDialog} autoComplete="off" >
          <form autoComplete="off">
            <Grid direction="row" spacing={3} container item  >
              <Grid item md={6} xs={12}>
                <InputV2
                  fullWidth
                  errors={methodsDialog.errors}
                  label="نام محصول"
                  name="productName"
                  rules={['required']}
                  register={methodsDialog.register}
                  control={methodsDialog.control}
                  dir="rtl"
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <InputCurrency
                  fullWidth
                  errors={methodsDialog.errors}
                  label="قیمت محصول "
                  name="priceProduct"
                  rules={['required']}
                  decimalPlaces={0}
                  minimumValue={0}
                  currency
                  register={methodsDialog.register}
                  control={methodsDialog.control}
                  dir="ltr"
                />
              </Grid>
            </Grid>
            <Grid direction="row" spacing={3} container item  >
              <Grid item md={6} xs={12}>
                <InputV2
                  fullWidth
                  errors={methodsDialog.errors}
                  label="موجودی محصول (تعداد)"
                  name="volumeProduct"
                  rules={['required', 'isNumeric', 'isInt']}
                  decimalPlaces={0}
                  minimumValue={0}
                  tooltip="سقف فروش محصول"
                  register={methodsDialog.register}
                  control={methodsDialog.control}
                  dir="ltr"
                />
              </Grid>


            </Grid>
          </form>
        </FormProvider>
      </SimpleDialog>
    </>
  );
}

const StyledTableCell = withStyles(() => ({
  root: {
    borderBottom: '1px solid #EEF0F2',
    textAlign: 'center'
  },

  table: {
    borderRadius: '10px ',
  },

  head: {
    color: '#667585',
    textAlign: 'center',
    backgroundColor: '#A1AAE312',
    padding: '10px ',
    fontSize: '13px',
    height: '50px',
    color: '#303d8f',
    '&:nth-child(2)': {
      minWidth: '120px',
    },
    '&:nth-child(3)': {
      minWidth: '120px',
    },

  },
  field: {
    background: '#fff'
  },

  body: {
    fontSize: 14,
    paddingTop: 0,
    paddingBottom: 0,

  },

}))(TableCell);

const StyledTableRow = withStyles(() => ({
  root: {
    '&:nth-child(even)': {
      backgroundColor: '#A1AAE312',

    },
    '& #my-helper-text': {
      height: '30px',
      lineHeight: '25px',
    },
    '& .MuiInputBase-input': {
      background: '#fff'
    },
    '& .MuiInputBase-formControl': {
      background: '#fff',
      overflow: 'hidden',
      borderRadius: 7,
    },
  },
}))(TableRow);


